import { render, staticRenderFns } from "./login2.vue?vue&type=template&id=aeefc658&scoped=true"
import script from "./login2.vue?vue&type=script&lang=js"
export * from "./login2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aeefc658",
  null
  
)

export default component.exports